const prod_settings =  {
    CASHBACK_URL: 'https://fiducial.cashway.fr'
}

export default prod_settings
